/* tslint:disable */
/* eslint-disable */

/**
 * Type de contrôleur (par rapport à sa classe de base)
 *
 * 0 = Base
 * 1 = ReadOnly
 * 2 = CRUD
 */
export enum ControllerType {
  Base = 0,
  ReadOnly = 1,
  CRUD = 2
}
